<template>
  <div class="market-container">
    <div class="market-top">
      <a-tabs v-model="marketCurrent" class="market-tabs" :class="{noCollect: !showCollect}" :animated="false">
        <div v-if="showCollect" slot="tabBarExtraContent" class="icon-position">
          <i
            class="icon-start"
            :class="{ 'star-light': filtedMyData.length && marketCurrent === 'myMarket' }"
          ></i>
        </div>
        <a-tab-pane v-if="showCollect" key="myMarket" :tab="$t('home.marketSet')"></a-tab-pane>
        <a-tab-pane key="futures" :tab="$t('market.futures')"></a-tab-pane>
        <a-tab-pane key="USDT" :tab="$t('market.exchange')"></a-tab-pane>
      </a-tabs>
      <a-input class="market-search" :placeholder="$t('home.searchSy')" v-model="searchName">
        <template #prefix>
          <img src="@/assets/svg/search.svg" />
        </template>
        <template #suffix>
          <img
            v-show="clearShow"
            class="cursor-p"
            @click="clearSearchName"
            src="@/assets/svg/clear.svg"
          />
        </template>
      </a-input>
    </div>
    <MarketTable :fromHome="fromHome" :marketCurrent.sync="marketCurrent" v-show="marketCurrent==='myMarket'" :tableData="filtedMyData"></MarketTable>
    <MarketTable :fromHome="fromHome" :marketCurrent.sync="marketCurrent" v-show="marketCurrent==='USDT'" :tableData="filtedExchangeData"></MarketTable>
    <MarketTable :fromHome="fromHome" :marketCurrent.sync="marketCurrent" v-show="marketCurrent==='futures'" :tableData="filtedFutureData"></MarketTable>
  </div>
</template>

<script>
import { myStorage } from '@/utilsui';
import MarketTable from './marketTable.vue';

export default {
  name: 'Market',
  components: {
    MarketTable,
  },
  props: {
    exchangeDataList: {
      type: Array,
      default: () => [],
    },
    futureDataList: {
      type: Array,
      default: () => [],
    },
    fromHome: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      marketCurrent: this.$route.query.current || 'futures',
      searchName: '',
    };
  },
  computed: {
    /**
     * 首页不展示自选
     */
    showCollect() {
      return !this.fromHome;
    },

    /**
     * 正则
     */
    reg() {
      return new RegExp(this.searchName, 'gim');
    },

    /**
     * 过滤自选
     */
    filtedMyData() {
      let datalist = [];
      const mySymbolList = myStorage.get('mySymbol') || [];
      datalist = [...this.exchangeDataList, ...this.futureDataList].filter(
        item => mySymbolList.includes(item.name),
      );
      return datalist.filter(item => item.name.match(this.reg));
    },

    /**
     * 过滤现货
     */
    filtedExchangeData() {
      return this.exchangeDataList.filter(item => item.name.match(this.reg));
    },

    /**
     * 过滤合约
     */
    filtedFutureData() {
      return this.futureDataList.filter(item => item.name.match(this.reg));
    },

    // 全部市场
    marketAllList() {
      if (this.$store.state.baseData.market) {
        const allMarket = this.$store.state.baseData.market.marketSort || [];
        return allMarket;
      }
      return [];
    },

    clearShow() {
      return !!this.searchName || false;
    },
  },
  mounted() {
    this.init();
    // this.marketCurrent = this.$route.query.current || 'futures'
  },
  methods: {
    init() {
      this.$store.dispatch('getCoinSymbolIntroduce');
    },
    getTabLabel(item) {
      const aliasMap = {
        USDT: this.$t('market.exchange'),
      };
      return aliasMap[item] || item;
    },

    clearSearchName() {
      this.searchName = '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";
.market-container {
  margin-top: 15px;
  min-height: 300px;
  ::v-deep .ant-tabs-bar {
    border-color: $gray-10;
  }
  .flex-box {
    height: 100%;
    display: flex;
    align-items: center;
  }
  .icon-start {
    width: 18px;
    height: 18px;
    background: url("../../../assets/svg/star-default.svg") no-repeat;
    display: inline-block;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    background-position: 1.5px;
    cursor: pointer;
  }
  ::v-deep .ant-tabs-nav-container {
    font-size: 16px;
    .ant-tabs-tab {
      color: $gray;
      padding: 20px 0;
      line-height: 18px;
      position: relative;
      font-weight: bold;
      margin-right: 28px;
    }
    .ant-tabs-tab-active {
      color: $light-ft;
    }
    .ant-tabs-ink-bar {
      background-color: $blue;
      width: 100px;
    }
    .ant-tabs-nav {
      margin-left: 22px;
    }
  }

  .noCollect {
    /deep/ .ant-tabs-nav {
      margin-left: 0;
    }
  }

  .market-top {
    position: relative;
    padding: 0 24px 12px;
    .icon-position {
      position: absolute;
      left: 0;
      top: 20px;
      width: 18px;
      height: 18px;
    }
  }
  .market-radio {
    ::v-deep.ant-radio-group {
      .ant-radio-button-wrapper {
        padding: 8px 10px;
        border: 0;
        font-size: 14px;
        border-radius: 4px;
        line-height: 16px;
        margin-right: 16px;
        box-sizing: border-box;
        background: $gray-10;
        color: $gray;
        font-weight: bold;
        &::before {
          width: 0;
        }
        &:focus-within {
          box-shadow: none;
        }
      }
      .ant-radio-button-wrapper-checked {
        background: $blue-10;
        color: $light-ft;
      }
    }
  }
  .market-search {
    position: absolute;
    right: 24px;
    top: 12px;
    width: 240px;
    ::v-deep.ant-input-affix-wrapper {
      .ant-input {
        height: 36px;
        color: $light-ft;
        background-color: $gray-10;
        border-color: transparent;
        &::placeholder {
          color: $gray;
        }
        &:hover,
        &:focus {
          border-color: $blue;
          box-shadow: none;
        }
        &:not(:first-child) {
          padding-left: 40px;
        }
        &-prefix {
          left: 16px;
        }
      }
    }
  }
  .star-light {
    width: 18px;
    height: 18px;
    background: url("../../../assets/svg/star-active.svg") no-repeat;
    background-position: 1.5px;
  }
  .cursor-p {
    cursor: pointer;
  }
}
.dark {
  .market-container {
    ::v-deep .ant-tabs-bar {
      border-color: $gray-10;
    }
    ::v-deep .ant-tabs-tab-active {
      color: $white;
    }
  }
  .market-search {
    ::v-deep.ant-input-affix-wrapper {
      .ant-input {
        color: $white;
        background-color: $dark-bg-second;
        border-color: $dark-bg-second;
      }
    }
  }
  .market-radio {
    ::v-deep.ant-radio-group {
      .ant-radio-button-wrapper {
        background-color: $dark-bg-second;
        color: $white;
      }
      .ant-radio-button-wrapper-checked {
        background: $blue-10;
        color: $blue;
      }
    }
  }
}
</style>
